import {
  DataEntityPresenterModel,
  DataEntityTypeEnum,
} from '@osos/shared/types';

export function canEditEntity(entity: DataEntityPresenterModel): boolean {
  if (isVirtualEntity(entity)) return false;

  return (
    !entity.isImplicit ||
    (entity.isImplicit && entity?.implicitOptions?.allowEdit)
  );
}

export function isVirtualEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.virtual?.enabled;
}

export function isVirtualProxyEntity(
  entity: DataEntityPresenterModel,
): boolean {
  return entity?.type === DataEntityTypeEnum.VirtualProxy;
}

export function isVirtualJoinerEntity(
  entity: DataEntityPresenterModel,
): boolean {
  return entity?.type === DataEntityTypeEnum.JoinerVirtualProxy;
}

export function isReadOnlyEntity(entity: DataEntityPresenterModel): boolean {
  return entity?.implicitOptions?.isReadOnly === true;
}

export function isNormalEntity(entity: DataEntityPresenterModel): boolean {
  return (
    !isVirtualJoinerEntity(entity) &&
    !isVirtualEntity(entity) &&
    !isVirtualProxyEntity(entity)
  );
}
